import defaultSource from "./defaultSource";

export default (function sourceRandomExponential(source) {
  function randomExponential(lambda) {
    return function() {
      return -Math.log(1 - source()) / lambda;
    };
  }

  randomExponential.source = sourceRandomExponential;

  return randomExponential;
})(defaultSource);



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-random/src/exponential.js
// module id = hEva
// module chunks = 0